import React, { useEffect } from 'react';
import orgConfig from 'org/configs/org.config';
import config from './configs';

function MobileCongratulations({ handleStartShoppingClick, redirectTimeout = 4500 }) {
  const handleStartShoppingButtonClick = () => {
    handleStartShoppingClick();
  };

  const { earnType } = orgConfig;
  const { image, getCongratsText, congratulationsTitle } = config;
  const congratsText = getCongratsText(earnType);

  useEffect(() => {
    const redirectedTimeout = setTimeout(handleStartShoppingButtonClick, redirectTimeout);
    return clearTimeout(redirectedTimeout);
  });

  return (
    <div className="mn_slide mn_slideCongrats">
      <div className="mn_content">
        <div className="mn_gap" />
        <div className="mn_congratulations">
          <img className="mn_checkmark" src={image} alt="" />
          <h2>{congratulationsTitle}</h2>
        </div>
        <p>{congratsText}</p>
        <div className="mn_bottomContent">
          <button
            className="mn_button mn_stepButton mn_stepButtonMobileDone"
            onClick={handleStartShoppingButtonClick}
          >
            Start shopping
          </button>
        </div>
      </div>
    </div>
  );
}

export default MobileCongratulations;
